import { useEffect, useState } from "react";
import { collection, doc, onSnapshot, query, where } from "firebase/firestore";
import { db } from "./FirebaseConfig.js";

import ecLogo from "./assets/EC-LogoFullColor.svg";

function Devo() {
  return (
    <div className="Home">
      <div className="w-screen h-screen flex flex-col justify-start items-center">
        <div className="w-full pt-5 px-5 flex flex-row justify-start items-center">
          <a
            className="w-fit h-fit block"
            href="https://elevationchurch.org/"
            target="_blank"
            rel="noreferrer"
          >
            <img className="w-20" src={ecLogo} alt="Elevation Church" />
          </a>
        </div>
        <div className="w-full h-fit py-5">
          <div className="w-full h-[0.15rem] bg-[#F2F2F2]" />
        </div>
        <div className="w-full h-fit lg:w-[75%] xl:w-[60%] pb-8 px-5 md:px-16 grid grid-cols-1 md:grid-cols-2 gap-5">
          <a
                key="digital"
                // style={{ "--image-url": `url(${dat.bgImage})` }}
                className="block w-full aspect-video bg-[url('https://storage.googleapis.com/nfc-connect-4addd.appspot.com/misc/Devo-Digital.jpg')] bg-cover bg-no-repeat rounded-2xl"
                href="https://www.bible.com/en/reading-plans/71792?source=TapTech"
                target="_blank"
                rel="noreferrer"
              >
                <div className="w-full h-full bg-transparent rounded-2xl p-5" />
              </a>
              <div className="flex flex-col items-center gap-3">
                <a
                  key="pdf"
                  // style={{ "--image-url": `url(${dat.bgImage})` }}
                  className="${dat.id} block w-full aspect-video bg-[url('https://storage.googleapis.com/nfc-connect-4addd.appspot.com/misc/Devo-PDF.jpg')] bg-cover bg-no-repeat rounded-2xl"
                  href="https://storage.googleapis.com/nfc-connect-4addd.appspot.com/misc/20260427_CAMP_DearChurch_OnePager.pdf?source=TapTech"
                  target="_blank"
                  rel="noreferrer"
                >
                  <div className="w-full h-full bg-transparent rounded-2xl p-5" />
                </a>
                <a
                  href="https://storage.googleapis.com/nfc-connect-4addd.appspot.com/misc/20260427_CAMP_DearChurch_OnePager_Spanish.pdf"
                  target="_blank"
                  rel="noreferrer"
                  className="text-sm font-medium text-[#00000080] hover:text-black transition-colors"
                >
                  Disponible en español
                </a>
              </div>
        </div>
        <h3 className="text-[#00000050] font-normal text-xs mt-auto pb-8">
          © 2024-2026 Elevation Church. <span className="font-medium">All Rights Reserved.</span>
        </h3>
      </div>
    </div>
  );
}

export default Devo;
